module.exports = __webpack_public_path__ + "static/media/00_disable_Pain_Free.29d391a7.svg";